import { protectedRoutes } from 'configs/routes.config'
import { getUserAuthority } from './permissionUtils'

const DEFAULT_FALLBACK_PATH = '/profile'
const NON_ENTRY_ROUTE_KEYS = new Set([
    'accessDenied',
    'profile',
    'notifications',
])

const hasRouteAuthority = (userAuthority = [], routeAuthority = []) => {
    if (!Array.isArray(routeAuthority) || routeAuthority.length === 0) {
        return true
    }

    if (!Array.isArray(userAuthority) || userAuthority.length === 0) {
        return false
    }

    if (userAuthority.includes('*')) {
        return true
    }

    return routeAuthority.some((authority) => userAuthority.includes(authority))
}

const isEntryRoute = (route) =>
    route?.path &&
    !route.path.includes(':') &&
    !route.key?.includes('.legacy') &&
    !NON_ENTRY_ROUTE_KEYS.has(route.key)

export const getDefaultAuthenticatedPath = (userOrAuthority) => {
    const userAuthority = Array.isArray(userOrAuthority)
        ? userOrAuthority
        : getUserAuthority(userOrAuthority)

    const route = protectedRoutes.find(
        (item) =>
            isEntryRoute(item) &&
            hasRouteAuthority(userAuthority, item.authority)
    )

    return route?.path || DEFAULT_FALLBACK_PATH
}

export const userCanAccessRoute = (userAuthority, routeAuthority) =>
    hasRouteAuthority(userAuthority, routeAuthority)
